module.exports = __webpack_public_path__ + "img/300x250_layout_1.9f585d55.svg";